module.exports = __webpack_public_path__ + "img/icone-mapa.d82a5cf7.svg";